import { Injectable } from '@angular/core';
import { Payment, PAYMENT_FEATURE_LAZY } from '@payment/const';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: PaymentService,
      feature: PAYMENT_FEATURE_LAZY,
      methods: [
        'getPayments',
        'getPaymentsLoading',
        'getPaymentsError',

        'deletePayment',
        'getDeletePaymentLoading',
        'getDeletePaymentError',
        'resetDeletePayment',

        'setActivePayment',
        'getActivePayment',
        'getBindPaymentLoading',
        'resetActivePayment',

        'getBindPaymentLater',
      ],
      async: true,
    }),
})
export abstract class PaymentService {
  abstract getPayments(): Observable<Payment[]>;
  abstract getPaymentsLoading(): Observable<boolean>;
  abstract getPaymentsError(): Observable<boolean>;

  abstract deletePayment(payment: Payment): void;
  abstract getDeletePaymentLoading(): Observable<boolean>;
  abstract getDeletePaymentError(): Observable<boolean>;
  abstract resetDeletePayment(): void;

  abstract setActivePayment(payment: Pick<Payment, 'bindingId'>): void;
  abstract resetActivePayment(): void;
  abstract getActivePayment(): Observable<Payment | null>;
  abstract getBindPaymentLoading(): Observable<boolean>;

  abstract getBindPaymentLater(): Observable<boolean>;
}
